export const DIRECT_MESSAGES_MESSAGE_TYPES = {
  TEXT: "MESG",
  FILE: "FILE",
};

export const DM_CHANNEL_KEYS = {
  uuid: "uuid",
  isEnabled: "is_enabled",
  unreadMessageCount: "unread_count",
  hasUnreadMention: "has_unread_mention",
  profile_pic: "profile_pic",

  metadata: "metadata",
  metadataChannelType: "channel_type",

  lastMessage: "last_message",
  lastMessageAt: "last_message_at",
  messageType: "message_type",
  message: "message",

  messageId: "message_id",
  messageCustomType: "custom_type",
  messageText: "message",
  messageCreatedAt: "created_at",
  messageData: "data",
  contentType: "content_type",
  url: "url",
  contentSize: "content_size",
  filename: "filename",

  data: "data",
  customType: "custom_type",
  file: "file",
  createdAt: "created_at",
  user: "user",

  userId: "user_id",
  profileUrl: "profile_url",
  requireAuthForProfileImage: "require_auth_for_profile_image",
  nickname: "nickname",
  user_metadata: "metadata",
  isBlockedByMe: "is_blocked_by_me",
  role: "role",
  isActive: "is_active",
  onlineStatus: "online_status",

  channelUrl: "channel_url",
  updatedAt: "updated_at",
  messageSurvivalSeconds: "message_survival_seconds",
  mentionedUsers: "mentioned_users",
  mentionType: "mention_type",
  silent: "silent",
  messageRetentionHour: "message_retention_hour",
  channelType: "channel_type",
  translations: "translations",
  isRemoved: "is_removed",

  isOpMsg: "is_op_msg",
  messageEvents: "message_events",
  sendPushNotification: "send_push_notification",
  updateUnreadCount: "update_unread_count",
  updateMentionCount: "update_mention_count",
  updateLastMessage: "update_last_message",
  customerUuid: "customer_uuid",
  customerEmail: "customer_email",
  phoneNumber: "phone_number",
  countryCode: "country_code",
  name: "name",
};

export const DM_MEMBER_KEYS = {
  channelUuid: "channel_uuid",
  memberUsername: "member_username",
  memberName: "member_name",
  memberEmail: "member_email",
  phoneNumber: "phone_number",
  profilePic: "profile_pic",
  onlineStatus: "online_status",
  description: "description",
};

export const DM_FILTER_SOURCE_KEYS = {
  messageStatus: "message_status",
  guestName: "guest_name",
};

export const CHANNEL_MESSAGE_STATUS = {
  UNREAD: 1,
};

export const DEFAULT_PROFILE_PIC =
  "/static/images/brandedCommunity/default_user_pic.png";
